// Guild leveling — 1000 XP per level, level = floor(xp/1000)+1 (the same
// formula as the credit_guild_xp DB function; keep them in sync).

export const GUILD_XP_PER_LEVEL = 1000;

export interface GuildLevelProgress {
  level: number;
  current: number;
  required: number;
  percentage: number;
}

export function guildLevelProgress(guildXp: number | null | undefined): GuildLevelProgress {
  const xp = Math.max(0, guildXp || 0);
  const current = xp % GUILD_XP_PER_LEVEL;
  return {
    level: Math.floor(xp / GUILD_XP_PER_LEVEL) + 1,
    current,
    required: GUILD_XP_PER_LEVEL,
    percentage: (current / GUILD_XP_PER_LEVEL) * 100,
  };
}
